// @flow
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';

import DropdownMultiInput from 'components/fragments/input/DropdownMultiInput';
import type { JobFilterType, JobFiltersType, JobFiltersSearchType } from 'types/JobFilter';
import type { RouterProps } from 'types/Router';

export function getFiltersOnQuery(query: JobFiltersSearchType, jobFilters: JobFiltersType) {
  const { domaines, typesContrats } = jobFilters;
  const { ...filters } = query;

  if (filters.domaine_emploi) {
    if (typeof filters.domaine_emploi === 'string') {
      filters.domaine_emploi = filters.domaine_emploi.split(',').map((value) => parseInt(value, 10));
    }

    filters.domaine_emploi = filters.domaine_emploi.reduce((acc, item) => {
      const value = parseInt(item, 10);

      return !acc.includes(value) && domaines.findIndex((d) => d.id === value) !== -1 ? acc.concat(value) : acc;
    }, []);
  }

  if (filters.type_contrat) {
    if (typeof filters.type_contrat === 'string') {
      filters.type_contrat = filters.type_contrat.split(',').map((value) => parseInt(value, 10));;
    }

    filters.type_contrat = filters.type_contrat.reduce((acc, item) => {
      const value = parseInt(item, 10);

      return !acc.includes(value) && typesContrats.findIndex((d) => d.id === value) !== -1 ? acc.concat(value) : acc;
    }, []);
  }

  return filters;
}

type Props = { jobFilters: JobFiltersType, onFilterChange: (filters: JobFiltersSearchType) => void } & RouterProps;

type State = {
  domaine_emploi: number[],
  type_contrat: number[],
  search: string,
}

class JobFilter extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = getFiltersOnQuery(queryString.parse(this.props.location.search), this.props.jobFilters);
  }

  getTitleName = () => ({
    typesContrats: 'Type de contrat',
    domaines: 'Domaines',
  });

  _convertToOptions = (jobFilter: Array<JobFilterType>): Array<Object> => {
    return jobFilter.map((filterjob) => ({ label: filterjob.name, value: filterjob.id }));
  }

  _convertToMultiOptions = (jobFilters: Object) => {
    const titles = Object.keys(jobFilters);
    const titlesName = this.getTitleName();

    return titles.reduce((result, title) => {
      result.push({ label: titlesName[title] });

      const filters = jobFilters[title].map((jobFilter) => ({
        label: jobFilter.name,
        value: jobFilter.id,
      }));

      return [
        ...result,
        ...filters,
      ];
    }, []);
  }

  _onMultiInputChange = (value: string) => {
    const { jobFilters: { domaines } } = this.props;
    const isDomaine = domaines.filter((filterJob) => filterJob.id.toString() === value.toString()).length > 0;
    const type = isDomaine ? 'domaine_emploi' : 'type_contrat';

    return this._onInputChange(type, value);
  }

  _onInputChange = (jobFilter: string, value: string) => {
    const filters = this.state;
    const jobs = filters[jobFilter] || [];

    let newState = [];
    if (jobs.includes(value)) {
      newState = jobs.filter(job => parseInt(job, 10) !== parseInt(value, 10));
    } else {
      newState = jobs.concat(value);
    }

    const newFilters = {
      ...filters,
      [jobFilter]: newState,
    };

    this.setState(newFilters);
    this.props.onFilterChange(newFilters);
  }

  onSearch = (event: SyntheticInputEvent<EventTarget>) => {
    const { value } = event.target;
    const filters = getFiltersOnQuery(queryString.parse(this.props.location.search), this.props.jobFilters);

    this.setState({ search: value });
    this.props.onFilterChange({ ...filters, search: value });
  }

  render() {
    const { jobFilters: { domaines, typesContrats } } = this.props;
    const {
      search,
      domaine_emploi: domainesState = [],
      type_contrat: typesContratsState = [],
    } = this.state;

    const {
      _convertToOptions,
      _convertToMultiOptions,
      _onInputChange,
      _onMultiInputChange,
      onSearch,
    } = this;

    return (
      <div className="header-filter header-filter--team header-filter--teamWfilter mt-2">
        <div className="row">
          <div className="col col-lg-8on9">
            <div className="header-filter__left">
              <div className="multi-dropdown">
                <div className="multi-dropdown__desktop">
                  <DropdownMultiInput
                    label="Type de contrat"
                    id="typesContrats"
                    options={_convertToOptions(typesContrats)}
                    inputChanged={(value) => _onInputChange('type_contrat', value)}
                    selected={typesContratsState}
                    className={'dropdown dropdown--noBorder dropdown--checkbox'}
                  />
                  <DropdownMultiInput
                    label="Domaines"
                    id="Domaines"
                    options={_convertToOptions(domaines)}
                    inputChanged={(value) => _onInputChange('domaine_emploi', value)}
                    selected={domainesState}
                    className={'dropdown dropdown--noBorder dropdown--checkbox'}
                  />
                </div>
                <div className="multi-dropdown__mobile">
                  <DropdownMultiInput
                    label="Autres filtres"
                    id="otherFilter"
                    options={_convertToMultiOptions({ typesContrats, domaines })}
                    inputChanged={(value) => _onMultiInputChange(value)}
                    selected={[...typesContratsState, ...domainesState]}
                    className={'dropdown dropdown--noBorder'}
                  />
                </div>
              </div>
            </div>
            <div className="header-filter__right">
              <form autoComplete="off">
                <div className="input input--dropdown" data-overlay={false}>
                  <input
                    type="search"
                    onChange={onSearch}
                    id="oi8234"
                    value={search}
                    placeholder="Saisir l'intitulé d'une offre"
                    autoComplete="off" />
                  <label htmlFor="oi8234">{`Saisir l'intitulé d'une offre`}</label>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(JobFilter);
